import { Instance } from 'mobx-state-tree';
import { VisitEditedDtoModelBase } from './VisitEditedDtoModel.base';

/* The TypeScript type of an instance of VisitEditedDtoModel */
export interface VisitEditedDtoModelType extends Instance<typeof VisitEditedDtoModel.Type> {}

/* A graphql query fragment builders for VisitEditedDtoModel */
export { selectFromVisitEditedDto, visitEditedDtoModelPrimitives, VisitEditedDtoModelSelector } from './VisitEditedDtoModel.base';

/**
 * VisitEditedDtoModel
 */
export const VisitEditedDtoModel = VisitEditedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
